import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line import/prefer-default-export
export const getPhotoIdReview = async (params) => api.get('/v2/reviews/photo-id', {
  params: {
    ...(params || {}),
    ...api.getLocaleParams(),
  },
});
